import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/documentNode';
import type { tag } from '@trello/utility-types';
import * as Apollo from '@apollo/client';
import process from 'process';
export type __OpaqueBrandRef = typeof tag;
export type MyMessagesDismissedFragment = (
  { __typename: 'Member' }
  & Pick<Types.Member, 'id'>
  & { messagesDismissed?: Types.Maybe<Array<(
    { __typename: 'Member_MessageDismissed' }
    & Pick<
      Types.Member_MessageDismissed,
      | 'id'
      | '_id'
      | 'count'
      | 'lastDismissed'
      | 'name'
    >
  )>> }
);

export const MyMessagesDismissedFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MyMessagesDismissed' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Member' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'messagesDismissed' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lastDismissed' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

interface UseMyMessagesDismissedFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<
      MyMessagesDismissedFragment,
      Apollo.OperationVariables
    >,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: (Apollo.StoreObject | Apollo.Reference) | null;
  returnPartialData?: boolean;
}

interface UseMyMessagesDismissedFragmentResult
  extends Omit<Apollo.UseFragmentResult<MyMessagesDismissedFragment>, 'data'> {
  data?: MyMessagesDismissedFragment;
}

export const useMyMessagesDismissedFragment = ({
  from,
  returnPartialData,
  ...options
}: UseMyMessagesDismissedFragmentOptions): UseMyMessagesDismissedFragmentResult => {
  const result = Apollo.useFragment<MyMessagesDismissedFragment>({
    ...options,
    fragment: MyMessagesDismissedFragmentDoc,
    fragmentName: 'MyMessagesDismissed',
    from:
      !from || !(from as Apollo.StoreObject)?.id
        ? null
        : { __typename: 'Member', ...from },
  });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    if (process.env.NODE_ENV === 'development') {
      if (
        localStorage.getItem('HIDE_FRAGMENT_WARNINGS') === 'false' ||
        localStorage.getItem('HIDE_FRAGMENT_WARNINGS') === null
      ) {
        console.warn('Fragment data is incomplete.', result);
      }
    }
    return {
      ...result,
      data: undefined,
    };
  }

  return { ...result, data: result.data as MyMessagesDismissedFragment };
};
